export default function ShopifyAddress({
  address: { address1, address2, city, country, province, zip },
}) {
  return (
    <>
      {address1 && <div key="address1">{address1}</div>}
      {address2 && <div key="address2">{address2}</div>}
      {city && <div key="city">{city}</div>}
      {province && <div key="province">{province}</div>}
      {country && <div key="country">{country}</div>}
      {zip && <div key="zip">{zip}</div>}
    </>
  )
}
